<template>
  <div>
    <el-col :span="6" v-for="item in result.data" :key="item.artiId" class="yi-cun-section-wrap">
      <div @click="handleDetail(item)" class="yi-cun-section">
        <div style="height:100px;position:relative">
          <img :src="item.imgUrl||$app.nodata.img" :alt="item.artiName" class="img-fluid" />
          <span class="day">{{item.fromSite||'--'}}天</span>
        </div>
        <h5 class="title" v-text="item.artiName"></h5>
        <p>作者：{{item.author ||'--'}}</p>
        <!-- <p>时间：{{item.modifyDate ||'--'}}</p> -->
        <p><i class="el-icon-view"></i>：{{item.showNum ||'--'}}</p>
      </div>
      <div class="bottom">&nbsp;</div>
    </el-col>
    <!-- <portal-comment-page :productedId="result.data.destId" productedType="spot"></portal-comment-page> -->
  </div>
</template>
<script>
require("../../styles/portal/culture.scss");
export default {
  data() {
    return {
      routeType: "arti",
      activeIndex: "6"
    };
  },
  mounted() {},
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    },
    result: {
      type: Object
    }
  },
  components: {
    BsPage: () => import("../../components/bs-page"),
    PortalCommentPage: () => import("./portal-comment-page")
  },
  methods: {
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/portal/arti/detail/${_module}/${_field}_detail/${item.artiId}`
      });
    }
  },
  created() {
    //this.$menuFn.setTitle("portal-from-detail");
  },
  watch: {}
};
</script>
<style lange="sass" scoped>
.day {
  position: absolute;
  width: 45px;
  height: 25px;
  filter: Alpha(opacity=0.6);
  background: rgba(245, 232, 210, 0.6);
  /* background: #f5e8d3; */
  border-radius: 15px;
  line-height: 25px;
  right: 2px;
  top: 2px;
  font-weight: bold;
}
p {
  text-align: left;
  margin-left: 10px;
  /* overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; */
}
</style>